export default __webpack_public_path__ + "static/media/file_image_1.ecf76216.svg";